import { Toaster } from 'sonner'

const AppToaster = () => {
  return (
    <Toaster
      position='top-right'
      richColors
      closeButton
      duration={3000}
      toastOptions={{
        style: {
          borderRadius: '12px',
        },
      }}
    />
  )
}

export default AppToaster
